// Continuous green (cheap) -> red (expensive) gradient for price-based map
// visualizations. Shared by FuelMap.jsx and DispatcherBoard.jsx so every
// price map in this project uses the same convention.
export function priceColor(price, min, max) {
  if (min === max) return "#f2a33d";
  const t = (price - min) / (max - min); // 0 = cheapest, 1 = priciest
  const r = Math.round(76 + t * (242 - 76));
  const g = Math.round(174 + t * (163 - 174));
  const b = Math.round(109 + t * (61 - 109));
  return `rgb(${r},${g},${b})`;
}
